export const FOOTER_COLORS = {
    BACKGROUND: '#252525',
    BORDER: '#F9B233',
};

export const SOCIAL_LINKS = {
    X: 'https://x.com/bc_eao?lang=en',
};
